import { FilterContext } from "components/filters/FilterContext";
import { useContext } from "react";
import { setArtist } from "utilities/coordinatorUtils";

export const SyncArtistFilterToNewAppointment = () => {
  const { getValue } = useContext(FilterContext);
  const artistFilter = getValue("artist");

  if (artistFilter.selectedArtists.length > 0) {
    setArtist(artistFilter.selectedArtists[0]);
  } else {
    setArtist(null);
  }

  return null;
};